import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight, FileText } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-20 md:py-32" ref={ref} data-id="element-89">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="gradient-border rounded-2xl p-8 md:p-12 text-center" data-id="element-91">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-92">
            ¿Tu empresa, institución u organización todavía no usa TruID?
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-93">
            Únete a cientos de plataformas que ya confían en TruID para proteger
            la identidad de sus usuarios mientras mejoran la experiencia
            digital.
          </p>

          <div className="flex items-center justify-center" data-id="element-94">
            <a href="mailto:contacto@truid.org" className="group bg-amber-500 hover:bg-amber-600 text-navy-900 px-8 py-4 rounded-lg font-semibold transition-all flex items-center space-x-2 shadow-lg shadow-amber-500/20 hover:shadow-amber-500/30" data-id="element-95">
              <span data-id="element-96">Contáctanos</span>
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-97" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}